import { React, useContext, useState } from "react";
import { Usercontext } from "../context/Usercontexte";
import LogoutIcon from "@mui/icons-material/Logout";
import Social_login from "../compenent/Social_login";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Uuser from "../assest/Uuser.svg";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom"; 
import Mode from "../compenent/Mode";
import Handedness from "../compenent/Handedness";
import ShareWith from "../compenent/ShareWith";
import { useTranslation } from "react-i18next";
import axios from 'axios';
import Masseege from "../compenent/masseege";
import LoadingBtn from "../compenent/LoadingBtn";
import { clearDataAndLogout } from "../Functions/Logout";
import { sendFcmT } from "../API/SendFcmT";
import  Linked from "../../src/assest/linked.svg";
import EditIcon from '@mui/icons-material/Edit';
 


function Account() {
  const { User, setUser, update, setUpdate, setReceiptes,Receiptes , setFirstFetch, setCard ,card } = useContext(Usercontext);
 
  const [OpenMode, setOpenMode] = useState(true);
  const [OpenHande, setOpenHande] = useState(true);
  const [OpenShare, setOpenShare] = useState(true);
  const [msg, setMsg] = useState({text:'' , color:''});
  const [IsLoading, setIsLoading] = useState(false);
  const {t , i18n} = useTranslation()
  var isArabic = i18n.language.startsWith('ar');

  const Navto = useNavigate();
 
    
// log out and clear all the data of the user 
  async function Logout() {
    clearDataAndLogout(setCard, setReceiptes, setUser, setFirstFetch);
    Navto("/");
    // Geting the fcm token and send it to the server 
    setReceiptes([])
   const FCMTOKEN = localStorage.getItem('FCMTOKEN')
   console.log('Receiptes from logout')

     
    axios.post('/api/clients/anonymous',{}).then((response)=> {
      const {data} = response;
      Cookies.set("access_token", "Token " + data.access_token);
      setUser(data.user)
       sendFcmT("Token " + data.access_token)
    } ).catch((error)=> {
      console.error()
      
    })
  }

// Selecting the img for uploading
    async function handleFileChange  (e) {
    const selectedFile = e.target.files[0];
    setIsLoading(true)
      const fileSizeInMB = selectedFile.size / (1024 * 1024); // Convert bytes to megabytes
      // Check if the file size is less than 2MB
      if (fileSizeInMB >= 5) {
        setMsg({
          text:  t('Msg.FileSizeExceed'),
          color: "bg-[#FF1203F5] text-[0.9rem]",
        });
         return;
      }  
     
        const token = Cookies.get("access_token");
        const headers = {
          'Accept': '*/*',
          'Connection': 'keep-alive',
          Authorization: token ,
        };
        const formData = new FormData();
    formData.append('profile_picture', selectedFile);
  try{
    const response = await axios.put( `https://django-cloudrun-5cc2zmgpqq-lz.a.run.app/api/clients/me` ,   formData  , { headers });
    setUser(response.data)    
    setMsg({
             text:t('Msg.PictureUpdateSuccess'),
             color: "  bg-[#4fd837]",
           });
           setUpdate(!update)
           setTimeout(() => {
            
             setIsLoading(false)
           }, 1000);
        }catch{
          setMsg({
                
                 text: t('Msg.PictureUpdateError'),
               color: "bg-[#FF1203F5]",
             });
           setIsLoading(false)

        }
   };


  <ChevronRightIcon />;
  return (
    <div className=" w-full flex  relative    flex-col p-[1.9rem] pb-28  ">
    <Masseege setMsg={setMsg}  msg={msg} />
      <Handedness OpenHande={OpenHande} setOpenHande={setOpenHande} />
      <Mode OpenMode={OpenMode} setOpenMode={setOpenMode} />
      <ShareWith OpenShare={OpenShare} setOpenShare={setOpenShare} />
      {!User?.is_anonymous && User ? (
        <div className="    absolute top-0   right-0  w-full bg-main h-[120px] ">
          <div className=" flex flex-col items-center   transform translate-x-[50%] right-1/2 absolute -bottom-20  ">
            <span className="    relative w-[120px] rounded-full  h-[120px] bg-white shadow-lg  ">
             
          { IsLoading &&   <span className=" absolute top-0 right-0 rounded-full  w-full h-full bg-white  bg-opacity-20">
              <LoadingBtn black={true} isLoading={IsLoading}/>
             </span>}
              <img
                src={  User?.profile_picture != null ? User?.profile_picture : Uuser     }
                className="  rounded-full  bg-cover object-cover w-full h-full"
                alt=""
              />
              <span className=" absolute  -bottom-2 right-3 p-2 bg-[#F3F3F3] rounded-full ">
          
                <label  htmlFor="fileupload" className="      border-solid border-[1px] relative overflow-hidden rounded-md items-center justify-center gap-2 flex flex-col " />
              <input
      
                type="file"
                accept="image/*" // Specify accepted file types if needed
                onChange={handleFileChange}
                multiple={false}
                style={{ display: 'none' }}
                id='fileupload'
              />
             <EditIcon className=" text-gray-500 "/>
                
              </span>
            </span>
            <h1 className=" mt-5 text-[#1D1A4As] font-[600] text-[1.3rem] ">
              {" "}
              {User ? User?.first_name + " " + User?.last_name : "unknown"}{" "}
            </h1>
          </div>
        </div>
      ) : (
        <Social_login isArabic={isArabic} t={t} />
      )}

      <div
        className={`  ${
          !User?.is_anonymous   && User       ? "pt-[14rem]" : "pt-[2rem]"
        }  flex flex-col   font-[500]`}
      >
        <span onClick={()=> setOpenShare(!OpenShare) } className= {` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}>
          <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
            <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#E9E8FF] rounded-full ">
           
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M8.46911 3.3068C8.46916 2.76067 8.66043 2.2318 9.00972 1.81198C9.35902 1.39216 9.84428 1.10789 10.3813 1.00851C10.9183 0.909136 11.4732 1.00092 11.9495 1.26795C12.4259 1.53497 12.7938 1.96037 12.9893 2.47031C13.1848 2.98026 13.1955 3.54255 13.0197 4.0596C12.8439 4.57664 12.4926 5.01581 12.0267 5.30086C11.5609 5.58591 11.01 5.69886 10.4695 5.6201C9.92912 5.54135 9.43334 5.27585 9.06824 4.8697L7.11406 5.93561L4.92758 7.18493C5.23326 7.72296 5.31343 8.36015 5.15054 8.95714L9.06824 11.094C9.45153 10.6681 9.97787 10.3979 10.5473 10.3346C11.1167 10.2712 11.6896 10.4192 12.1571 10.7505C12.6246 11.0817 12.9541 11.5731 13.0831 12.1313C13.2122 12.6896 13.1317 13.2757 12.857 13.7785C12.5823 14.2813 12.1325 14.6657 11.593 14.8587C11.0536 15.0517 10.462 15.0398 9.93074 14.8254C9.39945 14.6109 8.96542 14.2088 8.71108 13.6954C8.45674 13.182 8.39981 12.5931 8.5511 12.0405L4.63341 9.90437C4.33483 10.2365 3.94738 10.4761 3.51689 10.5949C3.0864 10.7136 2.6309 10.7066 2.20427 10.5746C1.77765 10.4426 1.39776 10.1912 1.10956 9.85008C0.821357 9.50895 0.636904 9.0924 0.578025 8.64973C0.519146 8.20705 0.588305 7.75677 0.777319 7.35217C0.966334 6.94757 1.26729 6.60557 1.64458 6.36666C2.02188 6.12774 2.45971 6.00191 2.90628 6.00403C3.35285 6.00616 3.78947 6.13617 4.16447 6.37866L6.5883 4.99341L8.5511 3.92246C8.49654 3.72179 8.46897 3.51475 8.46911 3.3068ZM10.8066 2.04813C10.6413 2.04813 10.4777 2.08068 10.325 2.14394C10.1723 2.20719 10.0335 2.2999 9.91663 2.41678C9.79975 2.53366 9.70703 2.67242 9.64378 2.82512C9.58053 2.97783 9.54797 3.1415 9.54797 3.3068C9.54797 3.47209 9.58053 3.63576 9.64378 3.78847C9.70703 3.94118 9.79975 4.07993 9.91663 4.19681C10.0335 4.31369 10.1723 4.4064 10.325 4.46965C10.4777 4.53291 10.6413 4.56546 10.8066 4.56546C11.1405 4.56546 11.4606 4.43285 11.6967 4.19681C11.9327 3.96076 12.0653 3.64061 12.0653 3.3068C12.0653 2.97298 11.9327 2.65283 11.6967 2.41678C11.4606 2.18074 11.1405 2.04813 10.8066 2.04813ZM2.89501 7.0828C2.56119 7.0828 2.24104 7.21541 2.005 7.45145C1.76895 7.6875 1.63634 8.00765 1.63634 8.34147C1.63634 8.67529 1.76895 8.99543 2.005 9.23148C2.24104 9.46753 2.56119 9.60014 2.89501 9.60014C3.22883 9.60014 3.54898 9.46753 3.78502 9.23148C4.02107 8.99543 4.15368 8.67529 4.15368 8.34147C4.15368 8.00765 4.02107 7.6875 3.78502 7.45145C3.54898 7.21541 3.22883 7.0828 2.89501 7.0828ZM9.54797 12.6569C9.54797 12.3231 9.68058 12.0029 9.91663 11.7669C10.1527 11.5308 10.4728 11.3982 10.8066 11.3982C11.1405 11.3982 11.4606 11.5308 11.6967 11.7669C11.9327 12.0029 12.0653 12.3231 12.0653 12.6569C12.0653 12.9907 11.9327 13.3109 11.6967 13.5469C11.4606 13.783 11.1405 13.9156 10.8066 13.9156C10.4728 13.9156 10.1527 13.783 9.91663 13.5469C9.68058 13.3109 9.54797 12.9907 9.54797 12.6569Z"
                  fill="#4F06C6"
                />
              </svg>
            </span>

            <h1 className=" text-[.9rem]  ">{t('profile.Share')} </h1>
          </div>

          <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
        </span>

        <h1 className="  py-[1.4rem] text-[.9rem] text-sec ">{t('profile.Settings')} </h1>

        <div className=" flex flex-col gap-[1.8rem] ">
          <Link
            to={"/PersonalInfo"}
            className={`    ${
              User && User?.is_anonymous == false ? " flex" : " hidden"
            }  ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }  justify-between items-center`}
          >
            <div className=  {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#D9FFDD] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M1.61273 11.3357C1.61273 10.5921 1.90811 9.87904 2.43389 9.35326C2.95966 8.82748 3.67277 8.5321 4.41633 8.5321H10.0235C10.7671 8.5321 11.4802 8.82748 12.006 9.35326C12.5317 9.87904 12.8271 10.5921 12.8271 11.3357C12.8271 11.7075 12.6794 12.064 12.4165 12.3269C12.1537 12.5898 11.7971 12.7375 11.4253 12.7375H3.01453C2.64275 12.7375 2.2862 12.5898 2.02331 12.3269C1.76042 12.064 1.61273 11.7075 1.61273 11.3357Z"
                    stroke="#06C671"
                    stroke-width="1.75225"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M7.21995 5.72859C8.38123 5.72859 9.32264 4.78718 9.32264 3.62589C9.32264 2.4646 8.38123 1.52319 7.21995 1.52319C6.05866 1.52319 5.11725 2.4646 5.11725 3.62589C5.11725 4.78718 6.05866 5.72859 7.21995 5.72859Z"
                    stroke="#06C671"
                    stroke-width="1.75225"
                  />
                </svg>
              </span>
            {/*  */}
              <h1 className=" text-[.9rem]  "> {t('profile.Personal')}</h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </Link>

          <Link
            to={"/linkedaccounts"}
            className={`    ${
              User && User?.is_anonymous == false ? " flex" : " hidden"
            }  ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }  justify-between items-center`}
          >
            <div className=  {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#FFE0FE] rounded-full ">
                 <img src={Linked} alt="Linked account" />
              </span>
            {/*  */}
              <h1 className=" text-[.9rem]  "> {t('profile.Personal')}</h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </Link>

          <Link
            to={"/Currency"}
            className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}
          >
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#FFFACA] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 20 13"
                  fill="none"
                >
                  <path
                    d="M2.12824 4.11405C2.75456 4.11405 3.35523 3.86524 3.7981 3.42237C4.24098 2.9795 4.48978 2.37883 4.48978 1.75251M2.12824 8.83712C2.75456 8.83712 3.35523 9.08593 3.7981 9.5288C4.24098 9.97168 4.48978 10.5723 4.48978 11.1987M17.8718 4.11405C17.2455 4.11405 16.6448 3.86524 16.202 3.42237C15.7591 2.9795 15.5103 2.37883 15.5103 1.75251M17.8718 8.83712C17.2455 8.83712 16.6448 9.08593 16.202 9.5288C15.7591 9.97168 15.5103 10.5723 15.5103 11.1987M1.34106 0.965332H18.659V11.9858H1.34106V0.965332ZM10 9.6243C11.3044 9.6243 12.3616 8.21525 12.3616 6.47559C12.3616 4.73592 11.3044 3.32687 10 3.32687C8.69568 3.32687 7.6385 4.73592 7.6385 6.47559C7.6385 8.21525 8.69568 9.6243 10 9.6243Z"
                    stroke="#FFE600"
                    stroke-width="1.57436"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('topbar.Ctoptitle')} </h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </Link>

          <span
            onClick={() => setOpenHande(!OpenHande)}
            className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}
          >
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#D5FFCA] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 12 15"
                  fill="none"
                >
                  <path
                    d="M11.9999 3.54162V12.4094C11.9999 13.7682 11.6424 14.5549 10.2836 14.5549H5.92121C5.27758 14.5549 4.63394 14.2688 4.20486 13.8397L0.91519 10.264L0.557617 9.54884C0.557617 8.83369 0.91519 8.83369 0.91519 8.83369C1.12973 8.83369 1.34428 8.83369 1.63033 8.97672L4.13334 10.264V2.61193C4.13334 2.11133 4.34789 1.68224 4.84849 1.68224C5.27758 1.68224 5.56363 2.18284 5.56363 2.68345V6.68826H6.27878V1.11013C6.27878 0.68104 6.49332 0.251953 6.99392 0.251953C7.49452 0.251953 7.70907 0.68104 7.70907 1.18164V6.68826H8.42421V1.68224C8.42421 1.18164 8.63876 0.752555 9.13936 0.752555C9.63996 0.752555 9.8545 1.18164 9.8545 1.68224V6.68826H10.5696V3.54162C10.5696 3.04102 10.7842 2.61193 11.2848 2.61193C11.7854 2.61193 11.9999 3.04102 11.9999 3.54162Z"
                    fill="#20AB00"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('profile.Hand')} </h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </span>

          <Link
            to={"/Language"}
            className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}
          >
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#FFD3CA] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                >
                  <path
                    d="M7.99991 14.7881C11.7884 14.7881 14.8597 11.7168 14.8597 7.92838C14.8597 4.13991 11.7884 1.0686 7.99991 1.0686M7.99991 14.7881C4.21144 14.7881 1.14014 11.7168 1.14014 7.92838C1.14014 4.13991 4.21144 1.0686 7.99991 1.0686M7.99991 14.7881C9.87076 14.7881 10.4944 11.6701 10.4944 7.92838C10.4944 4.18668 9.87076 1.0686 7.99991 1.0686M7.99991 14.7881C6.12906 14.7881 5.50545 11.6701 5.50545 7.92838C5.50545 4.18668 6.12906 1.0686 7.99991 1.0686M1.76375 10.4228H14.2361M1.76375 5.43391H14.2361"
                    stroke="#FF2B00"
                    stroke-width="1.24723"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('profile.Language')}</h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </Link>

          <span
            onClick={() => setOpenMode(!OpenMode)}
            className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}
          >
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#000] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.53819 1.1071C6.58827 0.996786 6.60763 0.874996 6.59423 0.75459C6.58083 0.634184 6.53517 0.519631 6.46206 0.423027C6.38895 0.326423 6.29111 0.251353 6.17888 0.205744C6.06664 0.160135 5.94417 0.145681 5.8244 0.163907C2.59588 0.659049 0.123535 3.44692 0.123535 6.81335C0.123535 10.5289 3.13543 13.5408 6.85101 13.5408C10.5666 13.5408 13.5785 10.5289 13.5785 6.81335C13.5784 6.75055 13.5775 6.68775 13.5758 6.62498C13.5724 6.50369 13.5363 6.38556 13.4713 6.28311C13.4063 6.18066 13.3148 6.09771 13.2065 6.04303C13.0981 5.98835 12.977 5.96399 12.856 5.97252C12.735 5.98105 12.6185 6.02216 12.5189 6.09149C11.7931 6.59697 10.9213 6.85006 10.0377 6.81183C9.15398 6.77361 8.30732 6.44619 7.62786 5.87992C6.94839 5.31365 6.47373 4.53987 6.27686 3.67756C6.07999 2.81525 6.1718 1.91215 6.53819 1.1071Z"
                    fill="white"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('profile.Mode')}</h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </span>
        </div>
        <h1 className="  py-[1.4rem] text-[.9rem] text-sec ">{t('profile.Other')}</h1>

        <div className=" flex flex-col gap-[1.8rem]">
          <span className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}>
            <Link to={'https://fintechracy.org/privacyPolicy'} className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#CAFFF9] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="15"
                  viewBox="0 0 12 15"
                  fill="none"
                >
                  <path
                    d="M6.11404 10.9628C6.32027 10.9628 6.49325 10.893 6.633 10.7532C6.77275 10.6135 6.84238 10.4407 6.84189 10.235V7.3236C6.84189 7.11738 6.77202 6.94439 6.63227 6.80464C6.49253 6.6649 6.31978 6.59527 6.11404 6.59575C5.90782 6.59575 5.73484 6.66563 5.59509 6.80537C5.45534 6.94512 5.38571 7.11786 5.3862 7.3236V10.235C5.3862 10.4412 5.45607 10.6142 5.59582 10.7539C5.73556 10.8937 5.90831 10.9633 6.11404 10.9628ZM6.11404 5.14006C6.32027 5.14006 6.49325 5.07018 6.633 4.93044C6.77275 4.79069 6.84238 4.61795 6.84189 4.41221C6.84189 4.20598 6.77202 4.033 6.63227 3.89325C6.49253 3.75351 6.31978 3.68387 6.11404 3.68436C5.90782 3.68436 5.73484 3.75423 5.59509 3.89398C5.45534 4.03373 5.38571 4.20647 5.3862 4.41221C5.3862 4.61843 5.45607 4.79142 5.59582 4.93116C5.73556 5.07091 5.90831 5.14054 6.11404 5.14006ZM6.11404 14.5293C6.02913 14.5293 5.95028 14.5232 5.87749 14.5111C5.80471 14.499 5.73192 14.4808 5.65914 14.4565C4.02148 13.9106 2.71742 12.9006 1.74696 11.4265C0.776492 9.95234 0.29126 8.36637 0.29126 6.66854V3.22945C0.29126 2.92619 0.379329 2.65324 0.555469 2.41063C0.731608 2.16801 0.958939 1.99211 1.23746 1.88294L5.60455 0.245278C5.77438 0.184624 5.94421 0.154297 6.11404 0.154297C6.28388 0.154297 6.45371 0.184624 6.62354 0.245278L10.9906 1.88294C11.2696 1.99211 11.4972 2.16801 11.6733 2.41063C11.8495 2.65324 11.9373 2.92619 11.9368 3.22945V6.66854C11.9368 8.36685 11.4516 9.95307 10.4811 11.4272C9.51067 12.9013 8.20661 13.9111 6.56895 14.4565C6.49616 14.4808 6.42338 14.499 6.35059 14.5111C6.27781 14.5232 6.19896 14.5293 6.11404 14.5293ZM6.11404 13.0736C7.37565 12.6733 8.4189 11.8727 9.24379 10.6717C10.0687 9.47075 10.4811 8.13636 10.4811 6.66854V3.22945L6.11404 1.5918L1.74696 3.22945V6.66854C1.74696 8.13636 2.1594 9.47075 2.9843 10.6717C3.80919 11.8727 4.85244 12.6733 6.11404 13.0736Z"
                    fill="#00BFA8"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('profile.Privacy')}</h1>
            </Link>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </span>

          <span className={` flex ${isArabic ? ' flex-row-reverse  justify-end ' :' flex-row' }   justify-between items-center`}>
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-[#E4CAFF] rounded-full ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="13"
                  viewBox="0 0 14 13"
                  fill="none"
                >
                  <path
                    d="M7.00806 0.428223L8.54227 5.15005H13.5071L9.49047 8.0683L11.0247 12.7901L7.00806 9.87188L2.99143 12.7901L4.52564 8.0683L0.509016 5.15005H5.47384L7.00806 0.428223Z"
                    fill="#8202B6"
                  />
                </svg>
              </span>

              <h1 className=" text-[.9rem]  ">{t('profile.Rate')}</h1>
            </div>

            <ChevronRightIcon className={` ${isArabic ?' rotate-180' :' rotate-0'}  scale-90`}  />
          </span>

          <div
            onClick={Logout}
            className={`    ${
              User && User?.is_anonymous == false ? " flex" : " hidden"
            }  flex-row  justify-between items-center pt-4`}
          >
            <div className= {`flex w-full ${isArabic ? ' flex-row-reverse   ' :' flex-row' } gap-[.8rem] items-center`} >
              <span className=" rotate-180  text-red-700 w-[2.2rem] items-center justify-center flex  h-[2.2rem] bg-red-200 rounded-full ">
                <LogoutIcon fontSize="" />
              </span>
              <h1 className="  text-[.9rem]  ">{t('profile.logout')}</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Account;
